import { render, staticRenderFns } from "./honor.vue?vue&type=template&id=392e4e04&"
import script from "./honor.vue?vue&type=script&lang=js&"
export * from "./honor.vue?vue&type=script&lang=js&"
import style0 from "./honor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('392e4e04')) {
      api.createRecord('392e4e04', component.options)
    } else {
      api.reload('392e4e04', component.options)
    }
    module.hot.accept("./honor.vue?vue&type=template&id=392e4e04&", function () {
      api.rerender('392e4e04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/description/components/honor.vue"
export default component.exports